import { DEFAULT_PLAYER_CONFIG } from "@tv4/avod-web-player-common";

import BackwardSvg from "../icons/BackwardIcon.svg";
import { useControls } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const SeekBackwardButton = () => {
  const controls = useControls();
  const SEEK_AMOUNT = DEFAULT_PLAYER_CONFIG.seekAmount;

  const translations = useTranslations();

  const seek = () => {
    controls?.seekBackward?.(SEEK_AMOUNT);
  };

  return (
    <PlayerControlButtonComponent
      aria-label={translations("player__a11y__label_skip_back", {
        seconds: SEEK_AMOUNT,
      })}
      aria-keyshortcuts={"←"}
      onClick={seek}
      interactive
      Icon={<BackwardSvg />}
      hoverText={translations("player__a11y__hover_label_seek_back_button", {
        seconds: SEEK_AMOUNT,
      })}
    ></PlayerControlButtonComponent>
  );
};

export default SeekBackwardButton;
